import { Component, Input, OnInit } from '@angular/core';
import {
  HANDOVER_OBSERVATION_DATA,
  HANDOVER_OBSERVATION_DATA_DIALOG_TITLE,
  HANDOVER_OBSERVATION_WELL_CONDITION,
  HANDOVER_OBSERVATION_WELL_CONDITION_DIALOG_TITLE,
} from 'src/app/handover-constants';
import { Handover } from 'src/app/interfaces/handover';
import {
  HandoverHistoryObservation,
  ObservationAttachment,
} from 'src/app/interfaces/handover-observation';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-handover-detail-footer-view',
  templateUrl: './handover-detail-footer-view.component.html',
  styleUrls: ['./handover-detail-footer-view.component.scss'],
  standalone: false,
})
export class HandoverDetailFooterViewComponent implements OnInit {
  @Input() wellName: string | undefined;
  @Input() handover: Handover | undefined;

  wellConditionhistoryObservations: HandoverHistoryObservation[] = [];
  handoverDataHistoryObservations: HandoverHistoryObservation[] = [];
  observationAttachment: any;
  dhoApiUrl = `${environment.urlBackend}/dhoapi`;

  constructor(
    private dialogService: DialogService,
    private handoverService: HandoverService
  ) {}

  ngOnInit(): void {
    this.getObservations();
    this.getObservationAttachments();
  }

  getObservations(): void {
    this.handoverService
      .getObservations(this.handover!.handoverId!)
      .subscribe((historyObservations: HandoverHistoryObservation[]) => {
        historyObservations.forEach((o) => {
          o.handoverObservationTypeDescription =
            o.handoverObservationTypeDescription.substr(0, 1).toUpperCase() +
            o.handoverObservationTypeDescription.substr(
              1,
              o.handoverObservationTypeDescription.length - 1
            );
        });
        this.wellConditionhistoryObservations = historyObservations.filter(
          (ho) =>
            ho.handoverObservationTypeId == HANDOVER_OBSERVATION_WELL_CONDITION
        );
        this.handoverDataHistoryObservations = historyObservations.filter(
          (ho) => ho.handoverObservationTypeId == HANDOVER_OBSERVATION_DATA
        );
      });
  }

  viewWellConditionObservationsHistory(): void {
    this.dialogService.openHandoverHistoryObservationsDialog(
      HANDOVER_OBSERVATION_WELL_CONDITION_DIALOG_TITLE,
      this.wellConditionhistoryObservations,
      this.handover?.sendingUser == undefined ? '' : this.handover?.sendingUser,
      this.handover?.sendingEngineerUser == undefined
        ? ''
        : this.handover?.sendingEngineerUser,
      this.handover!.handoverTypeId!
    );
  }

  viewDataHandoverObservationsHistory(): void {
    this.dialogService.openHandoverHistoryObservationsDialog(
      HANDOVER_OBSERVATION_DATA_DIALOG_TITLE,
      this.handoverDataHistoryObservations,
      this.handover?.sendingUser == undefined ? '' : this.handover?.sendingUser,
      this.handover?.sendingEngineerUser == undefined
        ? ''
        : this.handover?.sendingEngineerUser,
      this.handover!.handoverTypeId!
    );
  }

  getObservationAttachments(): void {
    if (this.handover?.handoverId) {
      this.handoverService
        .getObservationAttachments(this.handover?.handoverId)
        .subscribe((files: ObservationAttachment[]) => {
          if (files) {
            this.observationAttachment = files;
          }
        });
    }
  }
}
